import { useNavigate } from "react-router-dom"
import { ContactForm } from "../../../../../../types"
import { formatDateTimeFromTimestamp } from "../../../../../utils"

type Props = {
  info: ContactForm
}

const NameCell = ({ info }: Props) => {
  const navigate = useNavigate()
  const { name, id, created } = info

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer"
      onClick={() => navigate(`/config-admin/contact-form/${id}`)}
    >
      <div className="font-bold mr-2">{name || `Unnamed - ${id}`}</div>
      <div className="text-xs text-gray-400">
        {formatDateTimeFromTimestamp(created)}
      </div>
    </td>
  )
}

export default NameCell
